"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotTypes = exports.MetaTypes = exports.DetType = exports.LType = exports.Temps = exports.Nombre = exports.Genre = void 0;
var Genre;
(function (Genre) {
    Genre[Genre["Genre"] = -1] = "Genre";
    Genre[Genre["Masc"] = 0] = "Masc";
    Genre[Genre["Fem"] = 1] = "Fem";
})(Genre = exports.Genre || (exports.Genre = {}));
var Nombre;
(function (Nombre) {
    Nombre[Nombre["Nombre"] = -1] = "Nombre";
    Nombre[Nombre["Sin"] = 0] = "Sin";
    Nombre[Nombre["Plu"] = 1] = "Plu";
})(Nombre = exports.Nombre || (exports.Nombre = {}));
var Temps;
(function (Temps) {
    Temps[Temps["Temps"] = -1] = "Temps";
    Temps[Temps["Present"] = 0] = "Present";
})(Temps = exports.Temps || (exports.Temps = {}));
var LType;
(function (LType) {
    LType[LType["LType"] = -1] = "LType";
    LType[LType["Loc"] = 0] = "Loc";
    LType[LType["Int"] = 1] = "Int";
    LType[LType["Autre"] = 2] = "Autre";
})(LType = exports.LType || (exports.LType = {}));
var DetType;
(function (DetType) {
    DetType[DetType["DetType"] = -1] = "DetType";
    DetType[DetType["Des"] = 0] = "Des";
    DetType[DetType["Def"] = 1] = "Def";
    DetType[DetType["Ind"] = 2] = "Ind";
    DetType[DetType["Pos"] = 3] = "Pos";
    DetType[DetType["Qty"] = 4] = "Qty";
    DetType[DetType["Autre"] = 5] = "Autre";
})(DetType = exports.DetType || (exports.DetType = {}));
exports.MetaTypes = [
    Genre[-1],
    Nombre[-1],
    Temps[-1],
    LType[-1],
    DetType[-1],
];
exports.MotTypes = ["Determiant", "Nom", "Pronom", "Verbe"];
